var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStatus4(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 154.235,
    height: 159.554,
    viewBox: "0 0 154.235 159.554",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".a{fill:#d0b28a;}.b{fill:#b49770;}.c{fill:#e8d1b3;}.d{fill:#e6bc9b;}.e{fill:#d81212;}.f{fill:#f0f0f0;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(-168 -160)"
  }, /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M285.252,128l13.08,44.472a5.324,5.324,0,0,1,.216,1.5v76.353H256V128Z",
    transform: "translate(-10.883 69.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M338.659,349.162A2.659,2.659,0,0,1,336,346.5V290.659a2.659,2.659,0,0,1,5.318,0V346.5A2.659,2.659,0,0,1,338.659,349.162Z",
    transform: "translate(-64.29 -37.586)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M117.073,250.325H24V174.516a10.646,10.646,0,0,1,.317-2.579L37.3,128h93.073L117.39,171.936a10.648,10.648,0,0,0-.317,2.58Z",
    transform: "translate(144 69.229)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "a",
    d: "M45.318,80C42.381,80,40,83.572,40,87.978s2.381,7.978,5.318,7.978h95.732V80Z",
    transform: "translate(133.318 101.274)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "d",
    d: "M231.777,54.86a11.709,11.709,0,0,1-11.71,11.71H213.53a1.072,1.072,0,0,0-.658.226L196.276,79.7A9.05,9.05,0,0,1,184.32,66.161l16.375-16.375a1.072,1.072,0,0,0-.759-1.831H152l26.63-14.526A11.711,11.711,0,0,1,184.238,32h67.741a1.073,1.073,0,0,1,1.072,1.072V52.2a1.073,1.073,0,0,1-1.072,1.072H233.364a1.587,1.587,0,0,0-1.587,1.587Z",
    transform: "translate(58.548 133.318)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M424,16h21.274V50.57H424Z",
    transform: "translate(-123.039 144)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "b",
    d: "M304,469.3,317.3,456l13.3,13.3Z",
    transform: "translate(-42.927 -149.742)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M225.585,240l-1.579,22.191c-.019.42.315.825.923,1.124a5.352,5.352,0,0,0,2.307.459h3.02a5.351,5.351,0,0,0,2.307-.46c.609-.3.942-.7.923-1.124L231.907,240Z",
    transform: "translate(1.233 45.324)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M206.322,66.676V61.934L200,60.353S201.581,24,212.645,24V66.676Z",
    transform: "translate(20.496 218.648)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "e",
    d: "M81.585,176l-1.579,36.05a1.684,1.684,0,0,0,.923,1.43,4.39,4.39,0,0,0,2.307.585h3.02a4.39,4.39,0,0,0,2.307-.585,1.684,1.684,0,0,0,.923-1.43L87.907,176Z",
    transform: "translate(118.847 96.093)"
  }), /*#__PURE__*/React.createElement("path", {
    className: "f",
    d: "M78.121,24a1.616,1.616,0,0,0-1.476,1.631V41.386H73.484V25.634A1.617,1.617,0,0,0,72.008,24a1.581,1.581,0,0,0-1.686,1.577V41.386H67.161V25.634A1.616,1.616,0,0,0,65.685,24,1.581,1.581,0,0,0,64,25.58V45.6a6.322,6.322,0,0,0,1.264,3.793l3.477,4.636h6.322l3.477-4.636A6.322,6.322,0,0,0,79.806,45.6V25.58A1.581,1.581,0,0,0,78.121,24Z",
    transform: "translate(131.689 218.063)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatus4);
export default __webpack_public_path__ + "static/media/status-4.c435b95d70bdd473897eee438281710d.svg";
export { ForwardRef as ReactComponent };